import { render } from "./NetIncome.vue?vue&type=template&id=3551fec2&scoped=true"
import script from "./NetIncome.vue?vue&type=script&lang=js"
export * from "./NetIncome.vue?vue&type=script&lang=js"

import "./NetIncome.vue?vue&type=style&index=0&id=3551fec2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3551fec2"]])

export default __exports__